<template>
  <b-overlay :show="loading">
    <validation-observer ref="bankAPIForm" #default="{invalid}">
      <b-form ref="form" @submit.prevent="onCreateApiKey">
        <b-card
          class="blog-edit-wrapper"
        >
          <b-row>
            <b-col md="5" align-v="center">
             <b-form-group
                label="Name"
                label-for="name"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="Enter a name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="5">
              <b-form-group
                label="Allowed IPs"
                label-for="allowed-ips"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="allowed_ips"
                  rules=""
                >
                  <b-form-tags
                    id="allowed_ips"
                    v-model="allowed_ips"
                    placeholder="Enter a valid ip address eg. 192.168.0.1"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="mt-50"
            >
              <b-button
                class="mb-2"
                style="width: 200px"
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                Create Access key
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard, 
  BMedia, 
  BAvatar, 
  BCardText, 
  BMediaAside, 
  BMediaBody, 
  BForm, 
  BRow, 
  BCol, 
  BFormGroup, 
  BFormInput, 
  BImg, 
  BFormFile, 
  BLink, 
  BButton,
  BFormCheckbox,
  BFormTags,
  BFormText
} from "bootstrap-vue"

import { get } from "lodash";
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ListTable from "@/@core/components/ListTable/ListTable.vue";


export default {
  components: {
    BOverlay,
    BCard, 
    BMedia, 
    BAvatar, 
    BCardText, 
    BMediaAside, 
    BMediaBody, 
    BForm, 
    BRow, 
    BCol, 
    BFormGroup, 
    BFormInput, 
    BImg, 
    BFormFile, 
    BLink, 
    BButton,
    vSelect,
    BFormCheckbox,
    BFormTags,
    BFormText,

    // validations
    ValidationProvider,
    ValidationObserver,
    ListTable
  },
  directives: {
    Ripple,
  },
  data(){
    return {
      loading: false,
      name: "",
      allowed_ips: [],

      required
    }
  },
  computed: {
    merchantOptions() {
      return this.merchants.map(merchant => ({
        ...merchant, 
        label: merchant.name, 
        value: merchant._id
      }))
    },
    selectedMerchant() {
      return this.merchants.find(merchant => merchant._id === this.merchant_id)
    }
  },
  watch: {
    merchant_id: {
      handler() {
        this.fetchAPIEntities();
      }
    }
  },
  methods: {
    async onCreateApiKey(){
      try {
        this.loading = true;

        const { name, allowed_ips } = this
        
        await this.useJwt().mainService.apiKeys.create({
          name,
          allowed_ips
        });
    
        await this.$router.push({
          name: "admin-api-keys"
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'EditIcon',
            variant: 'success',
            text: `API Key created successfully`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
  @import '@core/scss/vue/pages/page-blog.scss';
</style>
